import Image1 from "../../assets/99freelas.png"
import Image2 from "../../assets/testimonial2.png"
import Image3 from "../../assets/testimonial3.png"

const Data = [
    {
      id: 1,
      image: Image1,
      title: "Renan S.",
      description:
        "Uma pessoa muito boa e de fácil comunicação. Recomendo demais o Mateus, um cara muito gente fina, ágil e sempre disposto a ajudar. Ele realiza o trabalho com competência e rapidez, tornando todo o processo mais eficiente e agradável. Estou muito satisfeito com a colaboração e, sem dúvida, trabalharei com ele novamente.",
    },
    {
      id: 2,
      image: Image1,
      title: "Anderson A.",
      description:
        "O Mateus fez um bom trabalho, gostei da entrega dele. Está iniciando ainda, mas é dedicado e atendeu todos meus pedidos a respeito do projeto.",
    },
   
  ];



  export default Data